module.exports = __webpack_public_path__ + "img/img4.a6d59545.png";